'use client';

// Updated import path
import { Loader2, LocateFixed } from 'lucide-react';
import { useTranslations } from 'next-intl';
import React from 'react';

import { LocationListItem } from '@ui/components/features/locationSearch/locationListItem';

interface CurrentLocationButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

export const CurrentLocationButton: React.FC<CurrentLocationButtonProps> = ({ onClick, disabled = false }) => {
  const t = useTranslations();

  return (
    <LocationListItem
      title={t('SearchPage.useCurrentLocation')}
      onClick={disabled ? undefined : onClick}
      icon={
        disabled ? (
          <Loader2 className="w-5 h-5 text-blue-500 animate-spin" />
        ) : (
          <LocateFixed className="w-5 h-5 text-blue-500" />
        )
      }
      iconBgClass="bg-blue-100"
      iconTextClass="text-blue-500"
      className={disabled ? 'opacity-50 cursor-not-allowed' : ''}
    />
  );
};
